import React from 'react';
import { auth } from '../firebase';
import { sendEmailVerification } from 'firebase/auth';

function UnverifiedNoticePage() {
  const user = auth.currentUser;

  const resendVerificationEmail = async () => {
    try {
      if (user && !user.emailVerified) {
        await sendEmailVerification(user);
        alert('Doğrulama e-postası tekrar gönderildi!');
      }
    } catch (error) {
      alert('Hata: ' + error.message);
    }
  };

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>📧 E-posta Doğrulaması Gerekli</h2>
      <p>
        Lütfen e-posta adresinizi doğrulayın. Gelen kutunuzu kontrol edin ve bağlantıya tıklayın.
      </p>
      <button onClick={resendVerificationEmail} style={{ padding: '0.5rem 1rem' }}>
        Doğrulama E-postasını Tekrar Gönder
      </button>
      <br />
      <button onClick={() => auth.signOut()} style={{ marginTop: '1rem', padding: '0.5rem 1rem' }}>
        Çıkış Yap
      </button>
    </div>
  );
}

export default UnverifiedNoticePage;
